import React from 'react';

import classnames from 'classnames';
import { Conditional } from 'common/components/layout';
import lodash from 'lodash';

import { Button, BUTTON } from 'components/common/Button/Button';
import { Spinner } from 'components/common/LoadingStatus/LoadingStatus';

import styles from './index.scss';

export function InputSection({ label, span, innerRef, required, error, children }) {
    return (
        <div className={styles.InputSection} span={span} ref={innerRef}>
            <label
                className={classnames(styles.InputSection__label, {
                    [styles.InputSection__required]: required,
                    [styles.InputSection__error]: error,
                })}
            >
                {label}
            </label>
            {children}
        </div>
    );
}

export function CreateDelegationForm({ children }) {
    return <div className={styles.CreateDelegationForm}>{children}</div>;
}

export function DOAInformationGroup({ children }) {
    return <div className={styles.DOAInformationGroup}>{children}</div>;
}

export function Header({ title, onClosePanel }) {
    return (
        <div className={styles.Header}>
            <h5>{title}</h5>
            <i className={styles.CloseIcon} onClick={onClosePanel}>
                close
            </i>
        </div>
    );
}

export function LoadingOverlay({ loading = false, actionLabel = 'Adding Delegation' }) {
    return (
        <Conditional condition={loading}>
            <div className={styles.LoadingOverlay}>
                <Spinner actionLabel={actionLabel} />
            </div>
        </Conditional>
    );
}

export function TaskSelectValueIndicator({ placeholderButtonLabel, value }) {
    if (!value) {
        return (
            <span className={styles.MultiSelectCheckbox__placeholder}>
                {placeholderButtonLabel}
            </span>
        );
    }
    if (Array.isArray(value)) {
        if (value.length === 0) {
            return (
                <span className={styles.MultiSelectCheckbox__placeholder}>
                    {placeholderButtonLabel}
                </span>
            );
        }
        return `${value.length} Study Task${value.length === 1 ? '' : 's'}`;
    }
    return value.label;
}

export function SignatureSelectValueIndicator({ placeholderButtonLabel, value }) {
    if (!value) {
        return (
            <span className={styles.MultiSelectCheckbox__placeholder}>
                {placeholderButtonLabel}
            </span>
        );
    }
    if (Array.isArray(value)) {
        if (value.length === 0) {
            return (
                <span className={styles.MultiSelectCheckbox__placeholder}>
                    {placeholderButtonLabel}
                </span>
            );
        }
        return `${value.length} Selected`;
    }
    return value.label;
}

export function SignatureSelectedIndicator({ signatures, onClose }) {
    return (
        <React.Fragment>
            {lodash.map(signatures, ({ label, data }, index) => (
                <div key={index} className={styles.SignatureSelectedIndicator}>
                    <div className={styles.SignatureSelectedIndicator__entry}>
                        <span className={styles.SignatureSelectedIndicator__label}>{label}</span>
                        <span className={styles.SignatureSelectedIndicator__role}>
                            {lodash.get(data, 'role')}
                        </span>
                    </div>
                    <Conditional condition={!!onClose}>
                        <i
                            className={styles.CloseIcon}
                            onClick={() => onClose(lodash.get(data, 'userId'))}
                        >
                            close
                        </i>
                    </Conditional>
                </div>
            ))}
        </React.Fragment>
    );
}

export function FooterSidePanel({
    onClosePanel, onEditDelegation, onDeleteDelegation, noCompletedSignatures, notOnStudyTeam, unableToSubmit, onRequesting
}) {

    return (
        <div className={styles.Footer}>
            <Button
                bgcolor={BUTTON.BGCOLOR.CLEAR}
                color={BUTTON.COLOR.BLACK}
                outline={BUTTON.OUTCOLOR.LIGHTGREY}
                onClick={onClosePanel}
                disabled={onRequesting}
            >
                Cancel
            </Button>
            <Conditional condition={noCompletedSignatures() && notOnStudyTeam()}>
                <Button
                    bgcolor={BUTTON.BGCOLOR.CLEAR}
                    color={BUTTON.COLOR.BLACK}
                    type={BUTTON.SIZE.SECONDARY}
                    onClick={onDeleteDelegation}
                    disabled={onRequesting}
                >
                    Delete Record
                </Button>
            </Conditional>
            <Button
                bgcolor={BUTTON.BGCOLOR.ORANGE}
                color={BUTTON.COLOR.WHITE}
                onClick={onEditDelegation}
                disabled={unableToSubmit || onRequesting}
            >
                {onRequesting ? 'Updating..' : 'Save Changes'}
            </Button>
        </div>
    );
}
